
import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function CheckboxUnselected(props: Partial<SVGProps<any>>) {
  return (
<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} className={twMerge('group', props.className)}>
<g filter="url(#filter0_d_4235_121010)">
<rect x="1" y="0.51001" width="16" height="16" rx="2" fill="transparent"/>
<rect x="1.5" y="1.01001" width="15" height="15" rx="1.5" className='stroke-gray-600 group-hover:!stroke-primary dark:stroke-secondary'/>
</g>
<defs>
<filter id="filter0_d_4235_121010" x="0" y="0.51001" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4235_121010"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4235_121010" result="shape"/>
</filter>
</defs>
</svg>

  )
}
